// This file was generated with `npm run icons:generate`. Don’t edit directly.
import Icon from 'tailwind/components/Icon/Icon';
import { IconOuterProps } from 'tailwind/components/Icon/Icon.types';

const UtilityStrokeArrowLeftSmallIcon = (props: IconOuterProps) => (
  <Icon {...props} viewBox="0 0 16 16">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.65151 7.64897C2.45625 7.84423 2.45625 8.16081 2.65151 8.35608L5.91974 11.6243C6.115 11.8196 6.43159 11.8196 6.62685 11.6243C6.82211 11.429 6.82211 11.1125 6.62685 10.9172L4.21214 8.50249L13.0259 8.50249C13.302 8.50249 13.5259 8.27863 13.5259 8.00249C13.5259 7.72635 13.302 7.50249 13.0259 7.50249L4.2122 7.50249L6.62685 5.08785C6.82211 4.89259 6.82211 4.576 6.62685 4.38074C6.43159 4.18548 6.115 4.18548 5.91974 4.38074L2.65151 7.64897Z"
      fill="var(--icon-color-main)"
    />
  </Icon>
);

export default UtilityStrokeArrowLeftSmallIcon;
